module.exports = __webpack_public_path__ + "img/switch-camera-icon.c946d371.svg";